import { render } from "./KeywordFilter.vue?vue&type=template&id=116644fc"
import script from "./KeywordFilter.vue?vue&type=script&lang=js"
export * from "./KeywordFilter.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__